export class AwsEc2AmiConvertResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "imageId",
            "baseName": "imageId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEc2AmiConvertResult.attributeTypeMap;
    }
    constructor() {
    }
}
